var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 24,
    viewBox: "0 0 134 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.75 0H0V24H68.25L72.75 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.689 19.023C10.251 19.023 12.078 17.49 12.078 14.97C12.078 12.912 10.797 11.589 8.886 11.022L7.206 10.518C5.967 10.119 5.274 9.468 5.274 8.355C5.274 6.927 6.387 6.192 7.647 6.192C9.117 6.192 9.999 6.969 10.209 8.397H12.036C11.763 6.003 10.272 4.449 7.647 4.449C5.316 4.449 3.384 5.961 3.384 8.46C3.384 10.203 4.392 11.61 6.45 12.219L8.109 12.744C9.453 13.185 10.209 13.794 10.209 15.075C10.209 16.398 9.264 17.28 7.689 17.28C6.261 17.28 5.19 16.608 4.917 14.907H3.069C3.342 17.574 5.022 19.023 7.689 19.023Z",
    fill: "#E20074"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9741 16.188H17.8481L15.2021 8.817H13.3121L17.0501 18.519L16.5671 19.8C16.2101 20.724 15.7481 20.976 15.0761 20.976C14.6771 20.976 14.3621 20.934 14.0471 20.85V22.278C14.4461 22.467 14.9081 22.53 15.3701 22.53C16.6931 22.53 17.6381 21.753 18.1631 20.367L22.4891 8.817H20.5991L17.9741 16.188Z",
    fill: "#E20074"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8668 8.544C27.6278 8.544 26.5778 9.111 26.0528 10.182H25.9478V8.817H24.2888V18.75H26.0528V13.143C26.0528 11.316 26.8508 10.161 28.3418 10.161C29.7278 10.161 30.2108 11.043 30.2108 12.345V18.75H31.9538V12.177C31.9538 9.951 31.0508 8.544 28.8668 8.544Z",
    fill: "#E20074"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1808 13.773C34.1808 17.007 35.7768 19.023 38.4438 19.023C40.6698 19.023 42.1188 17.658 42.4128 15.6H40.6278C40.3968 16.776 39.6198 17.406 38.4438 17.406C36.8268 17.406 35.9658 16.083 35.9658 13.773C35.9658 11.463 36.8268 10.161 38.4438 10.161C39.6198 10.161 40.3968 10.791 40.6278 11.967H42.4128C42.1188 9.909 40.6698 8.544 38.4438 8.544C35.7768 8.544 34.1808 10.539 34.1808 13.773Z",
    fill: "#E20074"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5486 19.023C52.7406 19.023 54.4626 17.175 54.4626 13.689V4.722H52.6356V13.437C52.6356 15.957 51.8166 17.238 49.5486 17.238C47.2596 17.238 46.4616 15.957 46.4616 13.437V4.722H44.6136V13.689C44.6136 17.175 46.3356 19.023 49.5486 19.023Z",
    fill: "#E20074"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6185 4.722V18.75H59.4455V13.521H62.3645C64.8005 13.521 66.7745 12.093 66.7745 9.132C66.7745 6.15 64.8005 4.722 62.3645 4.722H57.6185ZM59.4455 11.82V6.423H62.2175C63.6035 6.423 64.8635 7.221 64.8635 9.132C64.8635 11.022 63.6035 11.82 62.2175 11.82H59.4455Z",
    fill: "#E20074"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 18.75C81.507 18.75 83.859 16.377 84.636 11.946C85.455 7.326 83.586 4.722 80.205 4.722H75.879L73.401 18.75H78ZM77.727 6.801H79.764C81.864 6.801 82.956 8.397 82.347 11.757C81.759 15.117 80.226 16.671 78.147 16.671H76.005L77.727 6.801Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3888 4.722L85.9108 18.75H88.1368L89.0818 13.353H90.8038L92.7148 18.75H95.0668L92.9878 13.227C94.8778 12.828 96.2428 11.526 96.6418 9.279C97.1668 6.381 95.4658 4.722 93.0298 4.722H88.3888ZM94.3528 9.09C94.0798 10.602 93.0508 11.274 91.8328 11.274H89.4598L90.2578 6.801H92.6098C93.8698 6.801 94.6258 7.557 94.3528 9.09Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.079 4.722H99.8526L97.3746 18.75H99.6006L102.079 4.722Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.517 15.411H107.391L106.152 4.722H103.926L105.816 18.75H108.084L114.951 4.722H112.578L107.517 15.411Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.415 4.722H116.792L114.314 18.75H121.937L122.315 16.671H116.918L117.611 12.639H122.84L123.197 10.56H117.989L118.64 6.801H124.037L124.415 4.722Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.381 3.33612H127.5V3H129.653V3.33612H128.772V6.15767H128.381V3.33612Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.403 3H130.917L131.755 5.66532L132.565 3H133.084V6.15767H132.731V3.46868L131.945 6.15767H131.56L130.75 3.52076V6.15767H130.403V3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveMobileIcon);
export default __webpack_public_path__ + "static/media/drive-mobile-icon.02144817e761e88c98081c115268308b.svg";
export { ForwardRef as ReactComponent };